import { useState, useEffect } from "react";
import { ThemeProvider } from "./context/ThemeContext.tsx";
import { Navigation } from "./components/Navigation.tsx";
import { HomePage } from "./components/HomePage.tsx";
import { AboutPage } from "./components/AboutPage.tsx";
import { ServicesPage } from "./components/ServicesPage.tsx";
import { Footer } from "./components/Footer.tsx";
import ContactPage from "./pages/ContactPage.tsx";
import "./index.css";

function AppContent() {
  const [currentPage, setCurrentPage] = useState("home");
  const [mounted, setMounted] = useState(false);

  // Prevent hydration mismatch
  useEffect(() => {
    setMounted(true);
  }, []);

  const renderPage = () => {
    switch (currentPage) {
      case "home":
        return <HomePage onPageChange={setCurrentPage} />;
      case "about":
        return <AboutPage />;
      case "services":
        return <ServicesPage />;
      case "contact":
        return <ContactPage />;
      default:
        return <HomePage onPageChange={setCurrentPage} />;
    }
  };

  // Prevent rendering until mounted on the client
  if (!mounted) {
    return null;
  }

  return (
    <div className="min-h-screen flex flex-col bg-white dark:bg-gray-900 transition-colors duration-200">
      <Navigation currentPage={currentPage} onPageChange={setCurrentPage} />
      <main className="flex-1">
        {renderPage()}
      </main>
      <Footer onPageChange={setCurrentPage} />
    </div>
  );
}

export default function App() {
  return (
    <ThemeProvider>
      <AppContent />
    </ThemeProvider>
  );
}